import React from 'react';

const MaximizeBrandingSVG = ({ color, className, onClick, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      className={className}
      onClick={onClick}
      {...props}
    >
      <path
        d='M15 7L11 7M11 7L11 3M11 7L17 1'
        stroke={color}
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3 11L7 11M7 11L7 15M7 11L1 17'
        stroke={color}
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default MaximizeBrandingSVG;
